import React from 'react'
import { dateFormat } from 'helpers/date'
import { localisationMaster } from 'Localisation/Localisation'
import st from './InvoiceDetailInf.module.scss'

const InvoiceDetailInf = (props) => {
  return (
    <div className={st.containerHeader}>
      <div className={st.statusBox}>
        <div className={st.invoiceDetailInf}>
          {localisationMaster('text-answer-1', 'pays/payment/answer')}
        </div>
        <div className={st.statusDate}>
          {localisationMaster('pay-answer', 'pays/payment/answer')}:{' '}
          {dateFormat(new Date(props.payment_date), 'dd MMMM YYYY г.')}
        </div>
      </div>
      <div className={st.boxTitleAmount}>
        <li className={st.amounts}>
          <div className={st.nameTitle}>
            {localisationMaster('text-answer-2', 'pays/payment/answer')}:
          </div>
          <div className={st.priceTitle}>{props.id}</div>
        </li>
        <li className={st.amounts}>
          <div className={st.nameTitle}>
            {localisationMaster('invoice_id', 'pays/invoice')}:
          </div>
          <div className={st.priceTitle}>{props.order_id}</div>
        </li>
        <li className={st.amounts}>
          <div className={st.nameTitle}>
            {localisationMaster('text-answer-3', 'pays/payment/answer')}:
          </div>
          <div className={st.priceTitle}>
            {dateFormat(new Date(props.payment_date), 'YYYY-mm-dd')}
          </div>
        </li>
        <li className={st.amounts}>
          <div className={st.nameTitle}>
            {localisationMaster('text_32', 'modal_templates')}:
          </div>
          <div className={st.priceTitle}>{props.name_bank}</div>
        </li>
      </div>
    </div>
  )
}
export default InvoiceDetailInf
